//look at https://@material-ui/core.com/guides/migration-v0.x
// Tells `@material-ui/icons` to use `masterial-ui-next/SvgIcon` module
// instead of `masterial-ui/SvgIcon`.
import SvgIcon from '@material-ui/core/SvgIcon';
global.__MUI_SvgIcon__ = SvgIcon;

export default class Configuration {};